import { combineReducers } from '@reduxjs/toolkit';
import * as activity from 'features/activitySlice';
import * as category from 'features/categorySlice';
import * as article from 'features/articleSlice';

const rootReducer = combineReducers({
    activity: activity.activitySlice.reducer,
    category: category.categorySlice.reducer,
    article: article.articleSlice.reducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
